import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getAllDiariesByClassAndYear,
  updateRecordClassTaught,
  FormEdit,
  fetchLogo,
  GetMatter
} from "../../Api";
import LoadingSpinner from "../../components/Loading";
import {
  Container,
  AttendanceContainer,
  ContInfo,
  CtnrBtt,
  Button,
  ContTable,
  Table,
  TableHeader,
  TableBody,
  ToGoBack,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  Butons,
  ButtonPrint,
  UpperButons,
  Btt02,
  ButtonGroup,
  LessonsContainer,
  ContainerTable,
  Span,
  TableRow,
  DateCell,
  DescriptionCell,
  InfoText,
  HiddenOnPrint,
  StudentSection,
  PrintStyleLessons,
  EditContainer,
  ErrorMessage,
  ButtonEdit,
  AssessmentsContainer,
  GradesTableContainer,
  GradesTable,
  GradesTableHeader,
  GradesTableBody,
  LegendBox,
  ConceptsTableContainer,
  ConceptsTable,
  ConceptsTableHeader,
  ConceptsTableBody,
  IndividualContainerDivs,
  IndividualPrintStyle,
  IndividualStudentSection,
  IndividualContainerTable,
  IndividualTableRow,
  IndividualDescriptionCell,
  ContLogo,
  Preview,
  HeaderWrapper
  //ToggleButton,
} from "./style";

import ReactQuill from 'react-quill';
import { useRecuperacoes, NotaComRecF, COR_RECF } from '../../components/Recuperacao';

export default function Daily() {
  const { bimonthly } = useParams();
  const [data, setData] = useState(null);
  const [matters, setMatter] = useState([]);
  const [activeComponent, setActiveComponent] = useState(() => {
    return sessionStorage.getItem('activeComponent') || 'attendanceList';
  });
  const [assessmentFormat, setassessmentFormat] = useState('');
  //const [selectedTab, setSelectedTab] = useState("attendance"); // "attendance", "lessons", "grades"...

  const [expandedRows, setExpandedRows] = useState([]);
  const [printing, /*setPrinting*/] = useState(false);

  //const [recordClassTaught, setRecordClassTaught] = useState([]);
  const [positionAtSchool, setPositionAtSchool] = useState(null);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingId, setEditingId] = useState('');
  const [editedDescription, setEditedDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [expandedSections, setExpandedSections] = useState({
    regent: false,
    edfisica: false,
  });

  const [expandedAssessments, setExpandedAssessments] = useState([]);

  const [selectedStudentGrades, setSelectedStudentGrades] = useState(null);

  const [selectedStudentConcept, setSelectedStudentConcept] = useState(null);

  const [logoUrl, setLogoUrl] = useState('');

  const [loading, setLoading] = useState(true);

  const [assessmentRegime, setAssessmentRegime] = useState('');

  const { id_class, yearclss } = useParams();
  // recuperações lançadas na turma: o total do ano usa a nota que ficou após a recuperação
  const { recFinal, recFinalAno } = useRecuperacoes({ id_class });

  //const [finalData, setFinalData] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

      // matérias da escola na ordem do usuário (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar matérias:', e);
      }
      const position = localStorage.getItem('position_at_school');
      setPositionAtSchool(position);
      const $assessmentFormat = sessionStorage.getItem('assessmentFormat')
      setassessmentFormat($assessmentFormat)
      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }

      const res = await getAllDiariesByClassAndYear(
        id_class,
        yearclss
      );

      const dailies = res.data.dailiesByQuarter;

      console.log("dailies", dailies)
      // 🔹 pega regime (só do primeiro mesmo)
      const regime = dailies?.firstQuarter?.[0]?.id_iStQuarter?.assessmentRegime;
      setAssessmentRegime(regime);

      setData(dailies);
      setLoading(false);
    })();
  }, [id_class, yearclss]);

  const normalizeString = (str) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, "").toUpperCase();

  // formata data de nascimento "2019-11-19" -> "19/11/2019"
  const formatBirthDate = (dob) => {
    if (!dob) return "";
    const [y, m, d] = String(dob).split("T")[0].split("-");
    return d && m && y ? `${d}/${m}/${y}` : "";
  };
  const BirthDate = ({ cpf, dob }) =>
    (cpf || dob) ? (
      <div style={{ fontSize: "11px", fontWeight: "normal", color: "#666", lineHeight: 1.1 }}>
        {cpf && <div>CPF: {cpf}</div>}
        {dob && <div>Nasc: {formatBirthDate(dob)}</div>}
      </div>
    ) : null;

  const handleComponentChange = (component) => {
    if (activeComponent !== component) {
      sessionStorage.setItem('activeComponent', component);
      setActiveComponent(component); // Agora apenas atualiza o estado
    }
  };

  const toggleRowExpansion = (index) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  // função para alternar abertura
  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getDescriptionPreview = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = div.textContent || div.innerText || '';
    return text.length > 250 ? text.substring(0, 250) + '...' : text;
  };

  const isActive = (component) => activeComponent === component;

  const handlePrintAttendance = () => {
    const printContent = document.getElementById("printable-content-attendance");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
          <html>
            <head>
              <title>Impressão</title>
              <style>
              .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { 
                  text-align: center;
                  border: 1px solid #8c8c8c;
                  font-size: 12px;
                  padding: 1px; 
                }
                  tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                    
                  }
                  .name-cell {
                      text-align: start;
                  }
                      /* 🔥 FORÇA IMPRESSÃO DE CORES */
                  * {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }

                  /* 🔥 CORES DOS MESES */
                  .month-alt {
                    background-color: #d0d0d0 !important;
                  }

                  .month-normal {
                    background-color: #ffffff !important;
                  }

                  /* 🔥 (EXTRA) separação mesmo sem cor */
                  .month-alt,
                  .month-normal {
                    border-right: 1px solid #666;
                  }
                @page {
                  size: A4 landscape; /* Define o formato da página como paisagem */
                  margin: 0;
                }  
                ContTable {
                  overflow-x: hidden; /* Permite rolagem horizontal */
                  width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                  margin-left: auto; /* Centraliza horizontalmente */
                  margin-right: auto; /* Centraliza horizontalmente */
                }
                  .printable-content-attendance {
                    visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                    font-size: 15px;
                    //transform: scale(1); /* Ajusta a escala da tabela */
                  }
                .data {
                  display: flex;
                  gap:15px;
                }
                  .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
                .info {
                  display: flex;
                  flex-direction: column;
                }
                  .info span {
                    
                    font-size: 15px;
                  }
                  .no-print {
                    display: none !important;
                  }
                     /* ✅ Classes de status */
                     td.presence { 
                      color: green;
                      font-weight: bold; 
                    }
                    td.absence { 
                      color: red;
                      font-weight: bold; 
                    }
                    td.justifiedAbsence { 
                      color: #6a0dad;
                      font-weight: bold; 
                    }

                    td.total-presence {
                     color: #2ecc71; 
                      background-color: #e6f4ea; 
                    }
                    td.total-absence {
                     color: #e74c3c; 
                      background-color: #e6f4ea; 
                    }
                    td.total-justifiedAbsence {
                     color: #8e44ad; 
                      background-color: #e6f4ea; 
                    }
              </style>
            </head>
            <body>
              ${printContent.innerHTML} 
            </body>
          </html>
        `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintAttendancePhysicalEducation = () => {
    const printContent = document.getElementById("printable-content-attendancePhysicalEducation");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
          <html>
            <head>
              <title>Impressão</title>
              <style>
              .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { 
                  text-align: center;
                  border: 1px solid #8c8c8c;
                  font-size: 12px;
                  padding: 1px; 
                }
                  tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                    
                  }
                  .name-cell {
                      text-align: start;
                  }
                       /* 🔥 FORÇA IMPRESSÃO DE CORES */
                  * {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }

                  /* 🔥 CORES DOS MESES */
                  .month-alt {
                    background-color: #d0d0d0 !important;
                  }

                  .month-normal {
                    background-color: #ffffff !important;
                  }

                  /* 🔥 (EXTRA) separação mesmo sem cor */
                  .month-alt,
                  .month-normal {
                    border-right: 1px solid #666;
                  }
                @page {
                  size: A4 landscape; /* Define o formato da página como paisagem */
                  margin: 0;
                }  
                ContTable {
                  overflow-x: hidden; /* Permite rolagem horizontal */
                  width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                  margin-left: auto; /* Centraliza horizontalmente */
                  margin-right: auto; /* Centraliza horizontalmente */
                }
                  .printable-content-attendance {
                    visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                    font-size: 15px;
                    //transform: scale(1); /* Ajusta a escala da tabela */
                  }
                .data {
                  display: flex;
                  gap:15px;
                }
                  .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
                .info {
                  display: flex;
                  flex-direction: column;
                }
                  .info span {
                    
                    font-size: 15px;
                  }
                  .no-print {
                    display: none !important;
                  }
                      /* ✅ Classes de status */
                     td.presence { 
                      color: green;
                      font-weight: bold; 
                    }
                    td.absence { 
                      color: red;
                      font-weight: bold; 
                    }
                    td.justifiedAbsence { 
                      color: #6a0dad;
                      font-weight: bold; 
                    }

                    td.total-presence {
                     color: #2ecc71; 
                      background-color: #e6f4ea; 
                    }
                    td.total-absence {
                     color: #e74c3c; 
                      background-color: #e6f4ea; 
                    }
                    td.total-justifiedAbsence {
                     color: #8e44ad; 
                      background-color: #e6f4ea; 
                    }
              </style>
            </head>
            <body>
              ${printContent.innerHTML} 
            </body>
          </html>
        `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  const handlePrintClasses = async () => {
    toggleSection('regent');

    setExpandedRows(allClasses.map((_, index) => index));

    await sleep(500);

    const printContent = document.getElementById('print-area');
    if (!printContent) return;

    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;

    window.location.reload();
  };

  const handlePrintClassesEdFisica = async () => {
    toggleSection('edfisica');

    setExpandedRows(allClasses.map((_, index) => index));

    await sleep(500);

    const printContent = document.getElementById('print-areaEdFisica');
    if (!printContent) return;

    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;

    window.location.reload();
  };
  const handlePrintIndividualForm = async () => {
    setExpandedRows(data.id_individualForm.map((_, index) => index));

    // Espera meio segundo para o React aplicar a expansão do DOM
    await sleep(500);

    const printContent = document.getElementById('print-area');
    if (!printContent) return;

    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;

    // Recarrega a página para restaurar estados e eventos React
    window.location.reload();
  };

  const handleEdit = async (index, res) => {
    setDay(`${res.day}`);
    setMonth(`${res.month}`);

    setEditingIndex(index);
    setEditingId(res._id);
    setEditedDescription(res.description);
  }

  const handleSaveEdit = async () => {
    try {
      const res = await updateRecordClassTaught(editedDescription, day, month, editingId);
      if (res.data) {
        alert('Aula atualizada com sucesso!');
        setLoading(true);
        setEditingIndex(null);
        setErrorMessage('');
        const updatedLessons = data.id_recordClassTaught.map((item) =>
          item._id === editingId
            ? { ...item, description: editedDescription, day, month }
            : item
        );

        // Atualiza `data` com nova lista de aulas
        setData((prev) => ({
          ...prev,
          id_recordClassTaught: updatedLessons
        }));
        setLoading(false);
      } else {
        setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
      }
    } catch (error) {
      console.error("Erro ao atualizar aula:", error);
      setErrorMessage('Ocorreu um erro ao salvar a edição. Tente novamente.');
    }
  };
  //if (loading || !data) return <LoadingSpinner />;

  function toggleAssessment(index) {
    setExpandedAssessments(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  }

  function groupGradesByMatter() {
    const grouped = {};
    // cada período separado: precisamos da nota de cada período para aplicar a recuperação
    const periodos = [
      [1, data?.firstQuarter || []],
      [2, data?.secondQuarter || []],
      [3, data?.thirdQuarter || []],
      [4, data?.fourthQuarter || []],
    ];

    periodos.forEach(([numPeriodo, diarios]) => {
      diarios.forEach((q) => {
        (q.studentGrade || []).forEach((grade) => {
          const matter = grade.id_matter;
          const student = grade.id_student;

          if (!matter || !student) return;

          const matterId = matter._id;
          const studentId = student._id;

          const raw = grade.studentGrade;

          const gradeNumber = typeof raw === 'string'
            ? parseFloat(raw.replace(',', '.'))
            : Number(raw);

          const isHistorico = !grade.idActivity;

          if (!grouped[matterId]) {
            grouped[matterId] = {
              name: matter.name,
              students: {},
            };
          }

          if (!grouped[matterId].students[studentId]) {
            grouped[matterId].students[studentId] = {
              name: student.name,
              total: 0,
              porPeriodo: {},
              mediaPeriodo: {},
            };
          }

          const st = grouped[matterId].students[studentId];
          if (isHistorico) st.hasHistorico = true;

          const v = isNaN(gradeNumber) ? 0 : gradeNumber;
          st.total += v;
          st.porPeriodo[numPeriodo] = (st.porPeriodo[numPeriodo] || 0) + v;
          if (q.averageGrade !== undefined) st.mediaPeriodo[numPeriodo] = q.averageGrade;
        });
      });
    });

    // recuperação: troca a nota do período pela nota que ficou (regra da escola)
    Object.values(grouped).forEach((matterData) => {
      Object.entries(matterData.students).forEach(([studentId, st]) => {
        Object.entries(st.porPeriodo).forEach(([numPeriodo, notaPeriodo]) => {
          const final = recFinal(numPeriodo, studentId, matterData.name, notaPeriodo, st.mediaPeriodo[numPeriodo]);
          if (final !== null) {
            st.total += final - notaPeriodo;
            st.temRecuperacao = true;
          }
        });
      });
    });

    return grouped;
  }

  const groupedGradesRaw = groupGradesByMatter();

  // Reordena as matérias conforme a ordem definida pelo usuário (campo `order`
  // vindo do GetMatter), com a Educação Física no fim. Object.entries preserva
  // a ordem de inserção, então os pontos que iteram groupedGrades a herdam.
  const groupedGrades = (() => {
    const nrm = (s = '') =>
      s?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
    const orderIndex = new Map((matters || []).map((m, i) => [nrm(m.name), i]));
    const big = Number.MAX_SAFE_INTEGER;
    const entries = Object.entries(groupedGradesRaw).sort((a, b) => {
      const ia = orderIndex.has(nrm(a[1].name)) ? orderIndex.get(nrm(a[1].name)) : big;
      const ib = orderIndex.has(nrm(b[1].name)) ? orderIndex.get(nrm(b[1].name)) : big;
      return ia - ib;
    });
    return Object.fromEntries(entries);
  })();

  const groupedPhysical = Object.fromEntries(
    Object.entries(groupedGrades).filter(([_, matter]) =>
      (matter.name || '').toUpperCase().includes('EDUCA')
    )
  );

  function getAnnualGrades() {
    const quarters = [
      ...(data?.firstQuarter || []),
      ...(data?.secondQuarter || []),
      ...(data?.thirdQuarter || []),
      ...(data?.fourthQuarter || [])
    ];

    let total = 0;
    let average = 0;

    quarters.forEach(q => {
      total += Number(q.totalGrade) || 0;
      average += Number(q.averageGrade) || 0; // 🔥 SOMA DIRETO
    });

    return {
      total,
      average
    };
  }

  const annual = getAnnualGrades();

  const handlePrintgrades = () => {
    const printContent = document.getElementById("printable-content");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Impressão</title>
            <style>
            .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { 
                text-align: center;
                border: 1px solid #ddd;
                font-size: 11px;
                padding: 1px; 
              }
                tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                  
                }
                .name-cell {
                    text-align: start;
                }
              @page {
                size: A4 landscape; /* Define o formato da página como paisagem */
                margin: 0;
              }  
              ContTable {
                overflow-x: hidden; /* Permite rolagem horizontal */
                width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                margin-left: auto; /* Centraliza horizontalmente */
                margin-right: auto; /* Centraliza horizontalmente */
              }
                .printable-content {
                  visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                  font-size: 15px;
                  //transform: scale(1); /* Ajusta a escala da tabela */
                }
              .data {
                display: flex;
                gap:15px;
              }
                .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
              .info {
                display: flex;
                flex-direction: column;
              }
                /* ✅ NOVO: estilo para a legenda com borda */
            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 90px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
                .no-print {
                  display: none !important;
                }
                  /* ✅ As regras de cor que faltavam */
                .grade-red { color: #dc2626; }
                .grade-blue { color: #2563eb; }
                .grade-green { color: #16a34a; }
            </style>
          </head>
          <body>
            ${printContent.innerHTML} 
          </body>
        </html>
      `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintgradesPhysical = () => {
    const printContent = document.getElementById("printable-content-physical");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Impressão</title>
            <style>
            .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { 
                text-align: center;
                border: 1px solid #ddd;
                font-size: 11px;
                padding: 1px; 
              }
                tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                  
                }
                .name-cell {
                    text-align: start;
                }
              @page {
                size: A4 landscape; /* Define o formato da página como paisagem */
                margin: 0;
              }  
              ContTable {
                overflow-x: hidden; /* Permite rolagem horizontal */
                width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                margin-left: auto; /* Centraliza horizontalmente */
                margin-right: auto; /* Centraliza horizontalmente */
              }
                .printable-content {
                  visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                  font-size: 15px;
                  //transform: scale(1); /* Ajusta a escala da tabela */
                }
              .data {
                display: flex;
                gap:15px;
              }
                .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
              .info {
                display: flex;
                flex-direction: column;
              }
                /* ✅ NOVO: estilo para a legenda com borda */
            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 90px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
                .no-print {
                  display: none !important;
                }
                  /* ✅ As regras de cor que faltavam */
                .grade-red { color: #dc2626; }
                .grade-blue { color: #2563eb; }
                .grade-green { color: #16a34a; }
            </style>
          </head>
          <body>
            ${printContent.innerHTML} 
          </body>
        </html>
      `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintconcept = () => {
    const printContent = document.getElementById("printable-content-concepts");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
      <html>
        <head>
          <title>Impressão de Conceitos</title>
          <style>
          .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td {
              text-align: center;
              border: 1px solid #ddd;
              font-size: 11px;
              padding: 1px;
            }
            tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid; }

            .name-cell {
              text-align: start;
            }

            @page {
              size: A4 landscape; /* Formato paisagem */
              margin: 0;
            }

            ConceptsTableContainer {
              overflow-x: hidden;
              width: max-content;
              margin-left: auto;
              margin-right: auto;
            }

            .printable-content-concepts {
              visibility: visible;
              font-size: 15px;
            }

            .data {
              display: flex;
              gap: 15px;
            }
            .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
            .info {
              display: flex;
              flex-direction: column;
            }

            .no-print {
              display: none !important;
            }

            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 120px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
            .concept-green { color: #1d7f14; }
            .concept-blue { color: blue; }
            .concept-orange { color: orange; }
            .concept-red { color: red; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintconceptPhysical = () => {
    const printContent = document.getElementById("printable-content-concepts-physical");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
      <html>
        <head>
          <title>Impressão de Conceitos</title>
          <style>
          .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td {
              text-align: center;
              border: 1px solid #ddd;
              font-size: 11px;
              padding: 1px;
            }
            tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid; }

            .name-cell {
              text-align: start;
            }

            @page {
              size: A4 landscape; /* Formato paisagem */
              margin: 0;
            }

            ConceptsTableContainer {
              overflow-x: hidden;
              width: max-content;
              margin-left: auto;
              margin-right: auto;
            }

            .printable-content-concepts {
              visibility: visible;
              font-size: 15px;
            }

            .data {
              display: flex;
              gap: 15px;
            }
            .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
            .info {
              display: flex;
              flex-direction: column;
            }

            .no-print {
              display: none !important;
            }

            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 120px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
            .concept-green { color: #1d7f14; }
            .concept-blue { color: blue; }
            .concept-orange { color: orange; }
            .concept-red { color: red; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handleSaveEditIndForm = async () => {
    try {
      const res = await FormEdit({ update_idForm: editingId, editedDescription });

      if (res) {
        alert('Ficha atualizada com sucesso!');
        setLoading(true);

        setEditingIndex(null);

        setErrorMessage('');
        window.location.reload()
      } else {
        setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
      }
    } catch (error) {
      console.error("Erro ao atualizar aula:", error);
      setErrorMessage('Ocorreu um erro ao salvar a edição. Tente novamente.');
    }
  };

  const renderPeriod = (bimonthly) => {
    if (!bimonthly) return ''

    return assessmentRegime === 'TRIMESTRAL'
      ? bimonthly.replace(/Bimestre/gi, 'Trimestre')
      : bimonthly.replace(/Trimestre/gi, 'Bimestre')
  }

  // FREQUENCIAS
  const studentsSorted = React.useMemo(() => {
    const allStudents = [
      ...(data?.firstQuarter?.[0]?.id_student || []),
      ...(data?.secondQuarter?.[0]?.id_student || []),
      ...(data?.thirdQuarter?.[0]?.id_student || []),
      ...(data?.fourthQuarter?.[0]?.id_student || []),
    ];

    const unique = Array.from(
      new Map(allStudents.map((s) => [s._id, s])).values()
    );

    return unique.sort((a, b) =>
      normalizeString(a.name).localeCompare(normalizeString(b.name))
    );
  }, [data]);

  const transferSorted = React.useMemo(() => {
    const allTransfers = [
      ...(data?.firstQuarter?.[0]?.transferStudents || []),
      ...(data?.secondQuarter?.[0]?.transferStudents || []),
      ...(data?.thirdQuarter?.[0]?.transferStudents || []),
      ...(data?.fourthQuarter?.[0]?.transferStudents || []),
    ];

    const unique = Array.from(
      new Map(allTransfers.map((s) => [s._id, s])).values()
    );

    return unique.sort((a, b) =>
      normalizeString(a.name).localeCompare(normalizeString(b.name))
    );
  }, [data]);

  const quarters = {
    1: data?.firstQuarter?.[0] || {},
    2: data?.secondQuarter?.[0] || {},
    3: data?.thirdQuarter?.[0] || {},
    4: data?.fourthQuarter?.[0] || {},
  };

  const quartersPE = {
    1: {
      attendancePhysicalEducationTeacher:
        data?.firstQuarter?.[0]?.attendancePhysicalEducationTeacher || [],
    },
    2: {
      attendancePhysicalEducationTeacher:
        data?.secondQuarter?.[0]?.attendancePhysicalEducationTeacher || [],
    },
    3: {
      attendancePhysicalEducationTeacher:
        data?.thirdQuarter?.[0]?.attendancePhysicalEducationTeacher || [],
    },
    4: {
      attendancePhysicalEducationTeacher:
        data?.fourthQuarter?.[0]?.attendancePhysicalEducationTeacher || [],
    },
  };

  const getBimClass = (bim) => {
    return bim % 2 === 0 ? "month-alt" : "month-normal";
  };

  const periodLabel = assessmentRegime === 'TRIMESTRAL' ? 'TRIM' : 'BIM';

  const isTrimestral = periodLabel === "TRIM"; // ✅ corrigido
  const totalBimesters = isTrimestral ? 3 : 4;

  //AULAS
  const allClasses = React.useMemo(() => {
    return Object.values(data || {})
      .flatMap(b => b?.[0]?.id_recordClassTaught || []);
  }, [data]);

  const allRegentTeachers = Object.values(data || [])
    .flatMap(b => b?.[0]?.idRegentTeacher || []);

  const allRegentTeachers02 = Object.values(data || [])
    .flatMap(b => b?.[0]?.idRegentTeacher02 || []);

  const allPhysicalTeachers = Object.values(data || [])
    .flatMap(b => b?.[0]?.idPhysicalEducationTeacher || []);

  const getId = (value) => {
    if (!value) return null;
    if (typeof value === "string") return value;
    if (value._id) return value._id.toString();
    return value.toString();
  };

  //ATIVIDADES
  const allActivities = [
    ...(data?.firstQuarter?.[0]?.idActivity || []),
    ...(data?.secondQuarter?.[0]?.idActivity || []),
    ...(data?.thirdQuarter?.[0]?.idActivity || []),
    ...(data?.fourthQuarter?.[0]?.idActivity || []),
  ];

  //CONCEITOS FINAIS
  const finalConcepts = React.useMemo(() => {
    if (!data) return [];

    const all = [
      ...(data?.firstQuarter?.[0]?.id_FinalConcepts || []),
      ...(data?.secondQuarter?.[0]?.id_FinalConcepts || []),
      ...(data?.thirdQuarter?.[0]?.id_FinalConcepts || []),
      ...(data?.fourthQuarter?.[0]?.id_FinalConcepts || []),
    ];

    // 🔥 REMOVE DUPLICADOS (ALUNO + MATÉRIA)
    const unique = Array.from(
      new Map(
        all.map(item => [
          `${item.id_student?._id}-${item.id_matter?._id}`,
          item
        ])
      ).values()
    );

    return unique;
  }, [data]);

  function normalize(str) {
    return str
      ?.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
  }

  const finalConceptsPhysical = (data?.thirdQuarter?.[0]?.id_FinalConcepts || []).filter(c =>
    normalize(c.id_matter?.name).includes('EDUCACAO FISICA')
  );

  console.log("data", data)
  return (
    <Container>
      {loading ?
        <LoadingSpinner />
        :
        <>
          {/* Botões de navegação no topo */}
          <Butons>

            <UpperButons>
              <Btt02
                className={isActive('attendanceList') ? 'active' : ''}
                onClick={() => handleComponentChange('attendanceList')}
              >
                Frequência
              </Btt02>
              <Btt02 className={isActive('classes') ? 'active' : ''}
                onClick={() => handleComponentChange('classes')}
              >
                Aulas Lecionadas
              </Btt02>
              {assessmentFormat === 'grade' && (
                <ButtonGroup>
                  <Btt02 className={isActive('assessments') ? 'active' : ''}
                    onClick={() => handleComponentChange('assessments')}
                  >
                    Avaliações
                  </Btt02>
                  <Btt02
                    className={isActive('numericalGrades') ? 'active' : ''}
                    onClick={() => handleComponentChange('numericalGrades')}
                  >
                    Notas
                  </Btt02>
                </ButtonGroup>
              )}

              {assessmentFormat !== "grade"
                &&
                <Btt02
                  className={isActive('finalConcepts') ? 'active' : ''}
                  onClick={() => handleComponentChange('finalConcepts')}
                >
                  Conceitos Finais
                </Btt02>
              }

            </UpperButons>

          </Butons>

          {activeComponent === 'attendanceList' && (
            data?.firstQuarter ? (
              <>
                <AttendanceContainer id="printable-content-attendance" className="printable-content-attendance">
                  <HeaderWrapper className="HeaderWrapper">

                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <span><strong>Escola:</strong> {quarters[1]?.nameSchool}</span>
                      <span><strong>Ano:</strong> {quarters[1]?.year}</span>
                      {
                        console.log("dataquarters", quarters[1])
                      }
                      {quarters[1]?.serie && (
                        <span><strong>Série:</strong> {quarters[1]?.serie} - {quarters[1]?.idClass.level}</span>
                      )}

                      <span><strong>Turma:</strong> {quarters[1]?.nameClass}</span>
                      <span><strong>Professor(a) Regente Titular:</strong> {quarters[3]?.nameRegentTeacher}</span>

                      {quarters[3]?.nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor(a) Regente Adjunto:</strong> {quarters[1]?.nameRegentTeacher02}</span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintAttendance}>
                      Imprimir
                    </ButtonPrint>
                  </CtnrBtt>

                  <h2>Frequências anuais (Professor Regente)</h2>

                  <ContTable>
                    <Table>
                      <TableHeader>
                        <tr>
                          <th rowSpan={2}>Aluno</th>

                          {[...Array(totalBimesters)].map((_, index) => {
                            const bim = index + 1;
                            return (
                              <th key={bim} colSpan={3} className={getBimClass(bim)}>
                                {bim}º {periodLabel}
                              </th>
                            );
                          })}

                          <th colSpan={3} className={getBimClass(totalBimesters + 1)}>
                            TOTAL
                          </th>
                        </tr>

                        <tr>
                          {[...Array(totalBimesters + 1)].map((_, index) => {
                            const bim = index + 1;

                            return (
                              <React.Fragment key={bim}>
                                <th className={getBimClass(bim)}>P</th>
                                <th className={getBimClass(bim)}>F</th>
                                <th className={getBimClass(bim)}>FJ</th>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      </TableHeader>

                      <TableBody>

                        {/* 🔹 ALUNOS NORMAIS */}
                        {studentsSorted.map((student) => {

                          const getByBim = (bim) =>
                            (quarters[bim]?.attendance || []).filter(
                              a => a.id_student === student._id
                            );

                          const calc = (arr) => ({
                            totalPresence: arr.filter(a => a.status === "P").length,
                            totalAbsence: arr.filter(a => a.status === "F").length,
                            totalJustified: arr.filter(a => a.status === "FJ").length
                          });

                          const first = calc(getByBim(1));
                          const second = calc(getByBim(2));
                          const third = calc(getByBim(3));
                          const fourth = calc(getByBim(4));

                          const total = {
                            totalPresence: first.totalPresence + second.totalPresence + third.totalPresence + fourth.totalPresence,
                            totalAbsence: first.totalAbsence + second.totalAbsence + third.totalAbsence + fourth.totalAbsence,
                            totalJustified: first.totalJustified + second.totalJustified + third.totalJustified + fourth.totalJustified
                          };

                          return (
                            <tr key={student._id}>
                              <td>{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>

                              <td className={`presence ${getBimClass(1)}`}>{first.totalPresence}</td>
                              <td className={`absence ${getBimClass(1)}`}>{first.totalAbsence}</td>
                              <td className={`justifiedAbsence ${getBimClass(1)}`}>{first.totalJustified}</td>

                              <td className={`presence ${getBimClass(2)}`}>{second.totalPresence}</td>
                              <td className={`absence ${getBimClass(2)}`}>{second.totalAbsence}</td>
                              <td className={`justifiedAbsence ${getBimClass(2)}`}>{second.totalJustified}</td>

                              <td className={`presence ${getBimClass(3)}`}>{third.totalPresence}</td>
                              <td className={`absence ${getBimClass(3)}`}>{third.totalAbsence}</td>
                              <td className={`justifiedAbsence ${getBimClass(3)}`}>{third.totalJustified}</td>

                              {assessmentRegime !== 'TRIMESTRAL' && (
                                <>
                                  <td className={`presence ${getBimClass(4)}`}>{fourth.totalPresence}</td>
                                  <td className={`absence ${getBimClass(4)}`}>{fourth.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(4)}`}>{fourth.totalJustified}</td>
                                </>
                              )}

                              <td className={`total-presence ${getBimClass(5)}`}><strong>{total.totalPresence}</strong></td>
                              <td className={`total-absence ${getBimClass(5)}`}><strong>{total.totalAbsence}</strong></td>
                              <td className={`total-justifiedAbsence ${getBimClass(5)}`}><strong>{total.totalJustified}</strong></td>
                            </tr>
                          );
                        })}

                        {/* 🔹 TRANSFERIDOS */}
                        {transferSorted.length > 0 && (
                          <>
                            <tr>
                              <td colSpan={16} style={{
                                textAlign: "left",
                                fontWeight: "bold",
                                padding: "5px",
                                background: "var(--red-soft)",
                                color: "var(--red, #dc2626)",
                              }}>
                                ⚠️ Alunos Transferidos / Remanejados
                              </td>
                            </tr>

                            {transferSorted.map((student) => {

                              const getByBim = (bim) =>
                                (quarters[bim]?.attendance || []).filter(
                                  a => a.id_student === student._id
                                );

                              const calc = (arr) => ({
                                totalPresence: arr.filter(a => a.status === "P").length,
                                totalAbsence: arr.filter(a => a.status === "F").length,
                                totalJustified: arr.filter(a => a.status === "FJ").length
                              });

                              const first = calc(getByBim(1));
                              const second = calc(getByBim(2));
                              const third = calc(getByBim(3));
                              const fourth = calc(getByBim(4));

                              const total = {
                                totalPresence: first.totalPresence + second.totalPresence + third.totalPresence + fourth.totalPresence,
                                totalAbsence: first.totalAbsence + second.totalAbsence + third.totalAbsence + fourth.totalAbsence,
                                totalJustified: first.totalJustified + second.totalJustified + third.totalJustified + fourth.totalJustified
                              };

                              return (
                                <tr key={student._id}>
                                  <td>
                                    {student.name}{" "}
                                    <span style={{ color: "#e08a0b", fontWeight: "bold" }}>
                                      Transferido
                                    </span>
                                    <BirthDate cpf={student.cpf} dob={student.dateOfBirth} />
                                  </td>

                                  <td className={`presence ${getBimClass(1)}`}>{first.totalPresence}</td>
                                  <td className={`absence ${getBimClass(1)}`}>{first.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(1)}`}>{first.totalJustified}</td>

                                  <td className={`presence ${getBimClass(2)}`}>{second.totalPresence}</td>
                                  <td className={`absence ${getBimClass(2)}`}>{second.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(2)}`}>{second.totalJustified}</td>

                                  <td className={`presence ${getBimClass(3)}`}>{third.totalPresence}</td>
                                  <td className={`absence ${getBimClass(3)}`}>{third.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(3)}`}>{third.totalJustified}</td>

                                  {assessmentRegime !== 'TRIMESTRAL' && (
                                    <>
                                      <td className={`presence ${getBimClass(4)}`}>{fourth.totalPresence}</td>
                                      <td className={`absence ${getBimClass(4)}`}>{fourth.totalAbsence}</td>
                                      <td className={`justifiedAbsence ${getBimClass(4)}`}>{fourth.totalJustified}</td>
                                    </>
                                  )}

                                  <td className={`total-presence ${getBimClass(5)}`}><strong>{total.totalPresence}</strong></td>
                                  <td className={`total-absence ${getBimClass(5)}`}><strong>{total.totalAbsence}</strong></td>
                                  <td className={`total-justifiedAbsence ${getBimClass(5)}`}><strong>{total.totalJustified}</strong></td>
                                </tr>
                              );
                            })}
                          </>
                        )}

                      </TableBody>
                    </Table>
                  </ContTable>
                </AttendanceContainer>

                {/* ================= EDUCAÇÃO FÍSICA ================= */}

                <AttendanceContainer id="printable-content-attendancePhysicalEducation" className="printable-content-attendance">

                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <span><strong>Escola:</strong> {quarters[1]?.nameSchool}</span>
                      <span><strong>Ano:</strong> {quarters[1]?.year}</span>

                      {quarters[1]?.serie && (
                        <span><strong>Série:</strong> {quarters[1]?.serie} - {quarters[1]?.idClass.level}</span>
                      )}

                      <span><strong>Turma:</strong> {quarters[1]?.nameClass}</span>

                      {quarters[1]?.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor(a) de Ed. Física:</strong> {quarters[3]?.namephysicalEducationTeacher}</span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintAttendancePhysicalEducation}>
                      Imprimir
                    </ButtonPrint>
                  </CtnrBtt>

                  <h2>Frequências anuais (Educação Física)</h2>

                  <ContTable>
                    <Table>
                      <TableHeader>
                        <tr>
                          <th rowSpan={2}>Aluno</th>

                          {[...Array(totalBimesters)].map((_, index) => {
                            const bim = index + 1;
                            return (
                              <th key={bim} colSpan={3} className={getBimClass(bim)}>
                                {bim}º {periodLabel}
                              </th>
                            );
                          })}

                          <th colSpan={3} className={getBimClass(totalBimesters + 1)}>
                            TOTAL
                          </th>
                        </tr>

                        <tr>
                          {[...Array(totalBimesters + 1)].map((_, index) => {
                            const bim = index + 1;

                            return (
                              <React.Fragment key={bim}>
                                <th className={getBimClass(bim)}>P</th>
                                <th className={getBimClass(bim)}>F</th>
                                <th className={getBimClass(bim)}>FJ</th>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      </TableHeader>

                      <TableBody>

                        {/* 🔹 ALUNOS NORMAIS */}
                        {studentsSorted.map((student) => {

                          const getByBim = (bim) =>
                            (quartersPE[bim]?.attendancePhysicalEducationTeacher || []).filter(
                              a => a.id_student === student._id
                            );

                          const calc = (arr) => ({
                            totalPresence: arr.filter(a => a.status === "P").length,
                            totalAbsence: arr.filter(a => a.status === "F").length,
                            totalJustified: arr.filter(a => a.status === "FJ").length
                          });

                          const first = calc(getByBim(1));
                          const second = calc(getByBim(2));
                          const third = calc(getByBim(3));
                          const fourth = calc(getByBim(4));

                          const total = {
                            totalPresence: first.totalPresence + second.totalPresence + third.totalPresence + fourth.totalPresence,
                            totalAbsence: first.totalAbsence + second.totalAbsence + third.totalAbsence + fourth.totalAbsence,
                            totalJustified: first.totalJustified + second.totalJustified + third.totalJustified + fourth.totalJustified
                          };

                          return (
                            <tr key={student._id}>
                              <td>{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>

                              <td className={`presence ${getBimClass(1)}`}>{first.totalPresence}</td>
                              <td className={`absence ${getBimClass(1)}`}>{first.totalAbsence}</td>
                              <td className={`justifiedAbsence ${getBimClass(1)}`}>{first.totalJustified}</td>

                              <td className={`presence ${getBimClass(2)}`}>{second.totalPresence}</td>
                              <td className={`absence ${getBimClass(2)}`}>{second.totalAbsence}</td>
                              <td className={`justifiedAbsence ${getBimClass(2)}`}>{second.totalJustified}</td>

                              <td className={`presence ${getBimClass(3)}`}>{third.totalPresence}</td>
                              <td className={`absence ${getBimClass(3)}`}>{third.totalAbsence}</td>
                              <td className={`justifiedAbsence ${getBimClass(3)}`}>{third.totalJustified}</td>

                              {assessmentRegime !== 'TRIMESTRAL' && (
                                <>
                                  <td className={`presence ${getBimClass(4)}`}>{fourth.totalPresence}</td>
                                  <td className={`absence ${getBimClass(4)}`}>{fourth.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(4)}`}>{fourth.totalJustified}</td>
                                </>
                              )}

                              <td className={`total-presence ${getBimClass(5)}`}><strong>{total.totalPresence}</strong></td>
                              <td className={`total-absence ${getBimClass(5)}`}><strong>{total.totalAbsence}</strong></td>
                              <td className={`total-justifiedAbsence ${getBimClass(5)}`}><strong>{total.totalJustified}</strong></td>
                            </tr>
                          );
                        })}

                        {/* 🔹 TRANSFERIDOS (AGORA NA EDUCAÇÃO FÍSICA) */}
                        {transferSorted.length > 0 && (
                          <>
                            <tr>
                              <td colSpan={16} style={{
                                textAlign: "left",
                                fontWeight: "bold",
                                padding: "5px",
                                background: "var(--red-soft)",
                                color: "var(--red, #dc2626)",
                              }}>
                                ⚠️ Alunos Transferidos / Remanejados (Ed. Física)
                              </td>
                            </tr>

                            {transferSorted.map((student) => {

                              const getByBim = (bim) =>
                                (quartersPE[bim]?.attendancePhysicalEducationTeacher || []).filter(
                                  a => a.id_student === student._id
                                );

                              const calc = (arr) => ({
                                totalPresence: arr.filter(a => a.status === "P").length,
                                totalAbsence: arr.filter(a => a.status === "F").length,
                                totalJustified: arr.filter(a => a.status === "FJ").length
                              });

                              const first = calc(getByBim(1));
                              const second = calc(getByBim(2));
                              const third = calc(getByBim(3));
                              const fourth = calc(getByBim(4));

                              const total = {
                                totalPresence: first.totalPresence + second.totalPresence + third.totalPresence + fourth.totalPresence,
                                totalAbsence: first.totalAbsence + second.totalAbsence + third.totalAbsence + fourth.totalAbsence,
                                totalJustified: first.totalJustified + second.totalJustified + third.totalJustified + fourth.totalJustified
                              };

                              return (
                                <tr key={student._id}>
                                  <td>
                                    {student.name}{" "}
                                    <span style={{ color: "#e08a0b", fontWeight: "bold" }}>
                                      Transferido
                                    </span>
                                    <BirthDate cpf={student.cpf} dob={student.dateOfBirth} />
                                  </td>

                                  <td className={`presence ${getBimClass(1)}`}>{first.totalPresence}</td>
                                  <td className={`absence ${getBimClass(1)}`}>{first.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(1)}`}>{first.totalJustified}</td>

                                  <td className={`presence ${getBimClass(2)}`}>{second.totalPresence}</td>
                                  <td className={`absence ${getBimClass(2)}`}>{second.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(2)}`}>{second.totalJustified}</td>

                                  <td className={`presence ${getBimClass(3)}`}>{third.totalPresence}</td>
                                  <td className={`absence ${getBimClass(3)}`}>{third.totalAbsence}</td>
                                  <td className={`justifiedAbsence ${getBimClass(3)}`}>{third.totalJustified}</td>

                                  {assessmentRegime !== 'TRIMESTRAL' && (
                                    <>
                                      <td className={`presence ${getBimClass(4)}`}>{fourth.totalPresence}</td>
                                      <td className={`absence ${getBimClass(4)}`}>{fourth.totalAbsence}</td>
                                      <td className={`justifiedAbsence ${getBimClass(4)}`}>{fourth.totalJustified}</td>
                                    </>
                                  )}
                                  <td className={`total-presence ${getBimClass(5)}`}><strong>{total.totalPresence}</strong></td>
                                  <td className={`total-absence ${getBimClass(5)}`}><strong>{total.totalAbsence}</strong></td>
                                  <td className={`total-justifiedAbsence ${getBimClass(5)}`}><strong>{total.totalJustified}</strong></td>
                                </tr>
                              );
                            })}
                          </>
                        )}

                      </TableBody>
                    </Table>
                  </ContTable>

                </AttendanceContainer>
              </>
            ) : (
              <div style={{ padding: "2rem", textAlign: "center" }}>
                <h2>Nenhum dado de frequência encontrado.</h2>
              </div>
            )
          )}

          {activeComponent === 'classes' && (
            <>
              {/* 📘 AULAS DO PROFESSOR REGENTE (TITULAR / ADJUNTO) */}
              <StudentSection id='print-area'>

                <LessonsContainer>
                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintClasses}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  <ContLogo className="cont-logo-classes">
                    {logoUrl && <Preview className="logo-classes" src={logoUrl} alt="Logo da escola" />}
                    <h2>Registros de Aulas Anuais do {renderPeriod(bimonthly)} — Professor Regente</h2>
                  </ContLogo>

                  <ContInfo className="info">
                    <span><strong>Escola:</strong> {quarters[1]?.nameSchool}</span>
                  </ContInfo>

                  <h4 className="total-aulas-lecionadas">
                    Total de aulas lecionadas: {
                      allClasses.filter((res) => {

                        if (res?.teacher_type) {
                          return res.teacher_type === "REGENTE";
                        }

                        return (
                          allRegentTeachers.some(
                            (id) => id?.toString() === res?.id_teacher?._id?.toString()
                          ) ||
                          allRegentTeachers02.some(
                            (id) => id?.toString() === res?.id_teacher?._id?.toString()
                          )
                        );

                      }).length || 0
                    }
                  </h4>

                  <>
                    {allClasses?.length > 0 ? (
                      console.log("aulas", data.id_recordClassTaught),
                      allClasses.filter((res) => {

                        if (res?.teacher_type) {
                          return res.teacher_type === "REGENTE";
                        }

                        const teacherId = getId(res.id_teacher);

                        const isRegent1 = allRegentTeachers.some(
                          (id) => getId(id) === teacherId
                        );

                        const isRegent2 = allRegentTeachers02.some(
                          (id) => getId(id) === teacherId
                        );

                        return isRegent1 || isRegent2;
                      })
                        .sort((a, b) => new Date(a.year, a.month - 1, a.day) - new Date(b.year, b.month - 1, b.day))
                        .slice(0, expandedSections.regent ? undefined : 3)
                        .map((res, index) => (
                          <React.Fragment key={`regent-${index}`}>
                            <ContainerTable className="print-container-table">
                              <Span>
                                {
                                  res?.teacher_type === "REGENTE" ? (
                                    <>
                                      {res?.id_teacher && (
                                        <div>
                                          Professor(a) Titular:
                                          <p>{res.id_teacher.name}</p>
                                        </div>
                                      )}

                                      {res?.id_teacher02 && (
                                        <div>
                                          Professor(a) Adjunto:
                                          <p>{res.id_teacher02.name}</p>
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    res?.id_teacher ? (
                                      <>
                                        <div>
                                          Professor(a) Titular:
                                          <p>{res.id_teacher.name}</p>
                                        </div>

                                        {(res?.id_teacher02) &&
                                          <div>
                                            Professor(a) Adjunto:
                                            <p>
                                              {res?.id_teacher02?.name || quarters[1]?.nameRegentTeacher02}
                                            </p>
                                          </div>
                                        }
                                      </>
                                    ) : (
                                      <>
                                        {data.nameRegentTeacher &&
                                          data.nameRegentTeacher !== "Professor não definido" && (
                                            <div>
                                              Professor(a) Titular:
                                              <p>{data.nameRegentTeacher}</p>
                                            </div>
                                          )}

                                        <div>
                                          Professor(a) Adjunto:
                                          <p>{res.id_teacher.name}</p>
                                        </div>
                                      </>
                                    )
                                  )
                                }

                                {quarters[1]?.serie && (
                                  <span>
                                    <div>Serie: <p>{quarters[1].serie} - {quarters[1]?.idClass.level}</p></div>
                                  </span>
                                )}
                                <div>Turma: <p>{quarters[1].nameClass}</p></div>
                              </Span>

                              <TableRow>
                                <DateCell>{`${res.day}/${res.month}/${res.year}`}</DateCell>
                                <DescriptionCell>
                                  <div className={`description ${expandedRows.includes(index) ? 'expanded' : 'collapsed'}`}>
                                    <div
                                      style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                      dangerouslySetInnerHTML={{
                                        __html: expandedRows.includes(index) || printing
                                          ? res.description
                                          : getDescriptionPreview(res.description)
                                      }}
                                    />
                                  </div>

                                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {!printing && (
                                      <Button onClick={() => toggleRowExpansion(index)} className={HiddenOnPrint}>
                                        {expandedRows.includes(index) ? 'Ver Menos' : 'Ver Mais'}
                                      </Button>
                                    )}
                                    {expandedRows.includes(index) && positionAtSchool === 'DIRETOR/SUPERVISOR' && (
                                      <Button onClick={() => handleEdit(index, res)} className={HiddenOnPrint}>
                                        Editar
                                      </Button>
                                    )}
                                  </div>
                                </DescriptionCell>
                              </TableRow>
                              {editingIndex === index && (
                                <EditContainer>
                                  <div className="modal-content">
                                    <h3>Editando Aula</h3>
                                    <ReactQuill
                                      theme="snow"
                                      modules={{
                                        toolbar: [
                                          [{ 'font': [] }],
                                          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                          ['bold', 'italic', 'underline'],
                                          [{ 'color': [] }, { 'background': [] }],
                                          ['clean']
                                        ]
                                      }}
                                      value={editedDescription}
                                      onChange={(e) => setEditedDescription(e)}
                                      placeholder="Descrição da aula"
                                      style={{
                                        height: 'auto', // aumentado de 250px para 350px
                                        maxHeight: '550px',
                                        overflow: 'auto',
                                        zIndex: 0,
                                        position: 'relative'
                                      }}
                                    />
                                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                    <div style={{ position: 'relative', zIndex: 10, marginTop: '30px', }} className='BoxBtt'>
                                      <ButtonEdit onClick={handleSaveEdit}>Salvar</ButtonEdit>
                                      <ButtonEdit onClick={() => setEditingIndex(null)}>Cancelar</ButtonEdit>
                                    </div>
                                  </div>
                                </EditContainer>
                              )}
                            </ContainerTable>
                          </React.Fragment>
                        ))
                    ) : (
                      <InfoText>Nenhum registro de aulas encontrado para os professores regentes.</InfoText>
                    )}
                  </>
                  <h3
                    style={{ cursor: "pointer", textAlign: "center", marginBottom: "1rem" }}
                    onClick={() => toggleSection('regent')}
                    className="no-print"
                  >
                    {expandedSections.regent
                      ? "► Ver menos aulas"
                      : "▼ Ver todas as aulas"}
                  </h3>
                </LessonsContainer>
                <PrintStyleLessons />
              </StudentSection>
              {console.log("allclass", allClasses)}
              {/* 🏃‍♂️ AULAS DO PROFESSOR DE EDUCAÇÃO FÍSICA */}
              <StudentSection id='print-areaEdFisica'>
                <LessonsContainer>
                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintClassesEdFisica}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  <ContLogo className="cont-logo-classes">
                    {logoUrl && <Preview className="logo-classes" src={logoUrl} alt="Logo da escola" />}
                    <h2>Registros de Aulas Anuais do {renderPeriod(bimonthly)} — Professor de Educação Física</h2>
                  </ContLogo>

                  <ContInfo className="info">
                    <span><strong>Escola:</strong> {quarters[1]?.nameSchool}</span>
                  </ContInfo>

                  <h4 className="total-aulas-lecionadas">
                    Total de aulas lecionadas: {
                      allClasses.filter((res) => {

                        if (res?.teacher_type) {
                          return res.teacher_type === "ED_FISICA";
                        }

                        return allPhysicalTeachers.some(
                          (id) => id?.toString() === res?.id_teacher?._id?.toString()
                        );

                      }).length || 0
                    }
                  </h4>

                  <>
                    {allClasses?.length > 0 ? (
                      allClasses.filter((res) => {

                        if (res?.teacher_type) {
                          return res.teacher_type === "ED_FISICA";
                        }

                        return allPhysicalTeachers.some(
                          id => id?.toString() === res?.id_teacher?._id?.toString()
                        );
                      })

                        .sort((a, b) => new Date(a.year, a.month - 1, a.day) - new Date(b.year, b.month - 1, b.day))
                        .slice(0, expandedSections.edfisica ? undefined : 3)
                        .map((res, index) => (
                          <React.Fragment key={`pe-${index}`}>
                            <ContainerTable className="print-container-table">
                              <Span>
                                <div>Professor(a) de Ed. Física: <p>{res.id_teacher.name}</p></div>
                                {quarters[1]?.serie && (
                                  <span>
                                    <div>Serie: <p>{quarters[1].serie} - {quarters[1]?.idClass.level}</p></div>
                                  </span>
                                )}
                                <div>Turma: <p>{quarters[1].nameClass}</p></div>
                              </Span>

                              <TableRow>
                                <DateCell>{`${res.day}/${res.month}/${res.year}`}</DateCell>
                                <DescriptionCell>
                                  <div className={`description ${expandedRows.includes(index) ? 'expanded' : 'collapsed'}`}>
                                    <div
                                      style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                      dangerouslySetInnerHTML={{
                                        __html: expandedRows.includes(index) || printing
                                          ? res.description
                                          : getDescriptionPreview(res.description)
                                      }}
                                    />
                                  </div>

                                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {!printing && (
                                      <Button onClick={() => toggleRowExpansion(index)} className={HiddenOnPrint}>
                                        {expandedRows.includes(index) ? 'Ver Menos' : 'Ver Mais'}
                                      </Button>
                                    )}
                                    {expandedRows.includes(index) && positionAtSchool === 'DIRETOR/SUPERVISOR' && (
                                      <Button onClick={() => handleEdit(index, res)} className={HiddenOnPrint}>
                                        Editar
                                      </Button>
                                    )}
                                  </div>
                                </DescriptionCell>
                              </TableRow>
                              {editingIndex === index && (
                                <EditContainer>
                                  <div className="modal-content">
                                    <h3>Editando Aula</h3>
                                    <ReactQuill
                                      theme="snow"
                                      modules={{
                                        toolbar: [
                                          [{ 'font': [] }],
                                          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                          ['bold', 'italic', 'underline'],
                                          [{ 'color': [] }, { 'background': [] }],
                                          ['clean']
                                        ]
                                      }}
                                      value={editedDescription}
                                      onChange={(e) => setEditedDescription(e)}
                                      placeholder="Descrição da aula"
                                      style={{
                                        height: 'auto', // aumentado de 250px para 350px
                                        maxHeight: '550px',
                                        overflow: 'auto',
                                        zIndex: 0,
                                        position: 'relative'
                                      }}
                                    />
                                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                    <div style={{ position: 'relative', zIndex: 10, marginTop: '30px', }} className='BoxBtt'>
                                      <ButtonEdit onClick={handleSaveEdit}>Salvar</ButtonEdit>
                                      <ButtonEdit onClick={() => setEditingIndex(null)}>Cancelar</ButtonEdit>
                                    </div>
                                  </div>
                                </EditContainer>
                              )}
                            </ContainerTable>
                          </React.Fragment>
                        ))
                    ) : (
                      <InfoText>Nenhum registro de aulas encontrado para o professor de Educação Física.</InfoText>
                    )}
                  </>
                  <h3
                    className="no-print"
                    style={{ cursor: "pointer", textAlign: "center", marginBottom: "1rem" }}
                    onClick={() => toggleSection('edfisica')}
                  >
                    {expandedSections.edfisica
                      ? "► Ver menos aulas"
                      : "▼ Ver todas as aulas"}
                  </h3>
                </LessonsContainer>

                <PrintStyleLessons />
              </StudentSection>
            </>
          )}

          {activeComponent === 'assessments' && (
            <>
              {allActivities?.length > 0 ? (
                <AssessmentsContainer>
                  <h2>Avaliações do ano letivo de {quarters[1]?.year}</h2>

                  {allActivities
                    .slice() // cria uma cópia para não mutar o array original
                    .sort((a, b) => {
                      const nameA = a?.id_matter?.name?.toLowerCase() || '';
                      const nameB = b?.id_matter?.name?.toLowerCase() || '';
                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;
                      return 0;
                    })
                    .map((activity, index) => (
                      <div key={index} className="assessment-item">
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Disciplina:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity?.id_matter?.name || 'Não informado'}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Descrição:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity.descricao}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Tipo:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity.tipo}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Valor:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity.valor.toFixed(1).replace('.', ',')}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '8px' }}>
                          <strong style={{ marginRight: '6px' }}>Professor(a):</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity?.id_teacher?.name || 'Não informado'}
                          </span>
                        </div>
                        <div style={{ marginTop: '8px', textAlign: 'right' }}>
                          <button
                            onClick={() => toggleAssessment(index)}
                            style={{
                              background: '#007bff',
                              color: 'white',
                              border: 'none',
                              padding: '6px 12px',
                              borderRadius: '6px',
                              cursor: 'pointer',
                            }}
                          >
                            {expandedAssessments.includes(index) ? 'Fechar Notas' : 'Ver Notas'}
                          </button>
                        </div>
                        {expandedAssessments.includes(index) && (
                          <>
                            {activity.studentGrades && activity.studentGrades.length > 0 ? (
                              <table>
                                <thead>
                                  <tr>
                                    <th>Aluno</th>
                                    <th>Nota</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {activity.studentGrades.map((grade, idx) => (
                                    <tr key={idx}>
                                      <td>{grade?.id_student?.name || 'Aluno não informado'}</td>
                                      <td>
                                        {grade.studentGrade
                                          ? (typeof grade.studentGrade === 'number'
                                            ? grade.studentGrade.toFixed(1).replace('.', ',')
                                            : Number(grade.studentGrade.replace(',', '.')).toFixed(1).replace('.', ','))
                                          : '-'}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>

                              </table>
                            ) : (
                              <p>Nenhuma nota registrada para esta avaliação.</p>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                </AssessmentsContainer>
              ) : (
                <InfoText>
                  Nenhum dado de Avaliações encontrado para o {renderPeriod(data.bimonthly)}.
                </InfoText>
              )}
            </>
          )}

          {activeComponent === 'numericalGrades' && (
            <>
              <GradesTableContainer id="printable-content">
                <HeaderWrapper className="HeaderWrapper">
                  {(logoUrl) && (
                    <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                  )}
                  <ContInfo className="info">
                    <h2>Notas finais do ano letivo de {quarters[1]?.year}</h2>
                    <span><strong>Escola:</strong> {quarters[1]?.nameSchool}</span>

                    <span><strong>Ano:</strong> {quarters[1]?.year}</span>
                    {quarters[1]?.serie && (
                      <span><strong>Serie:</strong> {quarters[1]?.serie} - {quarters[1]?.idClass.level}</span>
                    )}
                    <span><strong>Turma:</strong> {quarters[1]?.nameClass}</span>
                    <span><strong>Professor(a) Regente Titular:</strong> {quarters[3]?.nameRegentTeacher}</span>
                    {quarters[3]?.nameRegentTeacher02 !== "Professor não definido" && (
                      <span><strong>Professor(a) Regente Adjunto:</strong> {quarters[3]?.nameRegentTeacher02}</span>
                    )}
                    {/*quarters[1]?.namephysicalEducationTeacher !== "Professor não definido" && (
                      <span><strong>Professor de Ed. Física:</strong> {quarters[1]?.namephysicalEducationTeacher}</span>
                    )*/}
                  </ContInfo>
                </HeaderWrapper>
                <CtnrBtt>
                  <ButtonPrint className="no-print" onClick={handlePrintgrades}>Imprimir</ButtonPrint>
                </CtnrBtt>
                <LegendBox className="legendBox">
                  <h3>Legenda</h3>
                  <p>
                    Nota Total Anual:{" "}
                    <strong style={{ color: 'var(--green)' }}>
                      {annual.total.toFixed(1)}
                    </strong>
                  </p>
                  <p>
                    Nota Média Anual:{" "}
                    <strong style={{ color: '#3b82f6' }}>
                      {annual.average.toFixed(1)}
                    </strong>
                  </p>
                  <p>
                    <strong style={{ color: COR_RECF }}>RecF=</strong> recuperação final
                  </p>
                </LegendBox>
                {Object.entries(groupedGrades).length > 0 ? (
                  console.log("groupedGrades", groupedGrades),
                  <div style={{ overflowX: 'auto' }}>
                    <GradesTable>
                      <GradesTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>
                          {Object.entries(groupedGrades).map(([matterId, matterData]) => (
                            <th key={matterId} className="matter-cell">
                              {matterData.name}
                            </th>
                          ))}
                        </tr>
                      </GradesTableHeader>
                      <GradesTableBody>
                        {Object.values(
                          Object.entries(groupedGrades).reduce((acc, [, matterData]) => {
                            Object.entries(matterData.students).forEach(([studentId, studentData]) => {
                              if (!acc[studentId]) {
                                acc[studentId] = { name: studentData.name, grades: {} };
                              }
                              acc[studentId].grades[matterData.name] = {
                                total: studentData.total,
                                hasHistorico: studentData.hasHistorico === true,
                                // recuperação final (anual): nota que ficou pela regra da escola
                                recF: recFinalAno(studentId, matterData.name, studentData.total)
                              };
                            });
                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem nota
                          (studentsSorted || []).reduce((acc, student) => {
                            acc[student._id] = { name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, grades: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student.name}
                              className={`grade-row ${selectedStudentGrades === student.name ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentGrades((prev) =>
                                  prev === student.name ? null : student.name
                                )
                              }
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                              {Object.entries(groupedGrades).map(([_, matterData]) => {
                                const notaObj = student.grades[matterData.name];
                                let notaClass = '';

                                if (notaObj) {
                                  const nota = parseFloat(notaObj.total) || 0;
                                  const isHistorico = notaObj.hasHistorico === true;

                                  const notaTotal = Number(annual.total);
                                  const notaMedia = Number(annual.average);

                                  if (isHistorico) {
                                    notaClass = 'grade-historico';
                                  } else if (nota >= notaTotal * 0.9) {
                                    notaClass = 'grade-green';
                                  } else if (nota >= notaMedia) {
                                    notaClass = 'grade-blue';
                                  } else {
                                    notaClass = 'grade-red';
                                  }
                                }

                                return (
                                  <td
                                    key={matterData.name}
                                    className={`matter-cell ${notaClass}`}
                                  >
                                    {notaObj
                                      ? <NotaComRecF nota={notaObj.total} recF={notaObj.recF} virgula />
                                      : '-'}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </GradesTableBody>
                    </GradesTable>
                  </div>
                ) : (
                  <GradesTable>
                    <tr><td>Não há nenhum registro</td></tr>
                  </GradesTable>
                )}
              </GradesTableContainer>

              {Object.entries(groupedPhysical).length > 0 && (
                <GradesTableContainer id="printable-content-physical">

                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <h2>Notas finais do ano letivo de {quarters[1]?.year}(Educação Física)</h2>

                      <span><strong>Escola:</strong> {quarters[1]?.nameSchool}</span>
                      <span><strong>Ano:</strong> {quarters[1]?.year}</span>

                      {quarters[1]?.serie && (
                        <span><strong>Serie:</strong> {quarters[1]?.serie} - {quarters[1]?.idClass.level}</span>
                      )}

                      <span><strong>Turma:</strong> {quarters[1]?.nameClass}</span>

                      <span>
                        <strong>Professor(a) de Ed. Física:</strong>{" "}
                        {quarters[3]?.namephysicalEducationTeacher}
                      </span>
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintgradesPhysical}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p>
                      Nota Total Anual:{" "}
                      <strong style={{ color: 'var(--green)' }}>
                        {annual.total.toFixed(1)}
                      </strong>
                    </p>
                    <p>
                      Nota Média Anual:{" "}
                      <strong style={{ color: '#3b82f6' }}>
                        {annual.average.toFixed(1)}
                      </strong>
                    </p>
                    <p>
                      <strong style={{ color: COR_RECF }}>RecF=</strong> recuperação final
                    </p>
                  </LegendBox>

                  <div style={{ overflowX: 'auto' }}>
                    <GradesTable>
                      <GradesTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>

                          {Object.entries(groupedPhysical).map(([matterId, matterData]) => (
                            <th key={matterId} className="matter-cell">
                              {matterData.name}
                            </th>
                          ))}
                        </tr>
                      </GradesTableHeader>

                      <GradesTableBody>
                        {Object.values(
                          Object.entries(groupedPhysical).reduce((acc, [, matterData]) => {
                            Object.entries(matterData.students).forEach(([studentId, studentData]) => {
                              if (!acc[studentId]) {
                                acc[studentId] = { name: studentData.name, grades: {} };
                              }

                              acc[studentId].grades[matterData.name] = studentData.total;
                              acc[studentId].recF = {
                                ...(acc[studentId].recF || {}),
                                [matterData.name]: recFinalAno(studentId, matterData.name, studentData.total)
                              };
                            });

                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem nota
                          (studentsSorted || []).reduce((acc, student) => {
                            acc[student._id] = { name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, grades: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student.name}
                              className={`grade-row ${selectedStudentGrades === student.name ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentGrades((prev) =>
                                  prev === student.name ? null : student.name
                                )
                              }
                            >

                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>

                              {Object.entries(groupedPhysical).map(([_, matterData]) => {
                                const nota = student.grades[matterData.name];
                                let notaClass = '';

                                if (nota) {
                                  const notaObj = parseFloat(nota) || 0;
                                  const isHistorico = nota.hasHistorico === true;
                                  console.log("obj", notaObj)
                                  const notaTotal = Number(annual.total);
                                  const notaMedia = Number(annual.average);

                                  if (isHistorico) {
                                    notaClass = 'grade-historico';
                                  } else if (notaObj >= notaTotal * 0.9) {
                                    notaClass = 'grade-green';
                                  } else if (notaObj >= notaMedia) {
                                    notaClass = 'grade-blue';
                                  } else {
                                    notaClass = 'grade-red';
                                  }
                                }

                                return (
                                  <td
                                    key={matterData.name}
                                    className={`matter-cell ${notaClass}`}
                                  >
                                    {nota ? <NotaComRecF nota={nota} recF={student.recF?.[matterData.name]} virgula /> : '-'}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </GradesTableBody>
                    </GradesTable>
                  </div>
                </GradesTableContainer>
              )}
            </>
          )}

          {activeComponent === 'concepts' && (
            data.studentConcept && data.studentConcept.length > 0 ? (
              <>
                <ConceptsTableContainer id="printable-content-concepts">
                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}
                    <ContInfo className="info">
                      <h2>Registro de Conceitos do {renderPeriod(bimonthly)}</h2>
                      <span><strong>Escola:</strong> {data.nameSchool}</span>

                      <span><strong>Ano:</strong> {data.year}</span>
                      {data?.serie && (
                        <span><strong>Serie:</strong> {data.serie}</span>
                      )}
                      <span><strong>Turma:</strong> {data.nameClass}</span>
                      <span><strong>Professor Regente Titular:</strong> {data.nameRegentTeacher}</span>
                      {data.nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor Regente Adjunto:</strong> {data.nameRegentTeacher02}</span>
                      )}
                      {data.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor de Ed. Física:</strong> {data.namephysicalEducationTeacher}</span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintconcept}>Imprimir</ButtonPrint>
                  </CtnrBtt>

                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p><strong style={{ color: 'var(--green)' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                    <p><strong style={{ color: '#3b82f6' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                    <p><strong style={{ color: '#e08a0b' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                    <p><strong style={{ color: 'var(--coral, #e5484d)' }}>D</strong> - Não alcançou as capacidades básicas</p>
                  </LegendBox>

                  {/* ✅ Somente a TABELA rola */}
                  <div style={{ overflowX: 'auto' }}>
                    <ConceptsTable>
                      <ConceptsTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>
                          {Array.from(
                            new Map(
                              data.studentConcept.map((c) => [
                                c.id_matter._id,
                                c.id_matter.name
                              ])
                            ).entries()
                          ).map(([matterId, matterName]) => (
                            <th key={matterId} className="matter-cell">{matterName}</th>
                          ))}
                        </tr>
                      </ConceptsTableHeader>

                      <ConceptsTableBody>
                        {Object.values(
                          data.studentConcept.reduce((acc, concept) => {
                            const studentId = concept.id_student._id;
                            if (!acc[studentId]) {
                              acc[studentId] = {
                                _id: studentId,
                                name: concept.id_student?.name || 'Sem nome',
                                cpf: concept.id_student?.cpf,
                                dateOfBirth: concept.id_student?.dateOfBirth,
                                concepts: {}
                              };
                            }
                            acc[studentId].concepts[concept.id_matter._id] = concept.studentGrade;
                            return acc;
                          }, {})
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student._id}
                              className={`concept-row ${selectedStudentConcept === student._id ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentConcept((prev) =>
                                  prev === student._id ? null : student._id
                                )
                              }
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                              {Array.from(
                                new Map(
                                  data.studentConcept.map((c) => [
                                    c.id_matter._id,
                                    c.id_matter.name
                                  ])
                                ).keys()
                              ).map((matterId) => {
                                const concept = student.concepts[matterId] || '-';
                                let conceptClass = '';
                                if (concept === 'A') conceptClass = 'concept-green';
                                else if (concept === 'B') conceptClass = 'concept-blue';
                                else if (concept === 'C') conceptClass = 'concept-orange';
                                else if (concept === 'D') conceptClass = 'concept-red';

                                return (
                                  <td key={matterId} className={`matter-cell ${conceptClass}`}>
                                    {concept}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </ConceptsTableBody>
                    </ConceptsTable>
                  </div>
                </ConceptsTableContainer>
              </>
            ) : (
              <ConceptsTableContainer>
                <div style={{ overflowX: 'auto' }}>
                  <ConceptsTable>
                    <tr>
                      <td>Não há conceitos registrados</td>
                    </tr>
                  </ConceptsTable>
                </div>
              </ConceptsTableContainer>
            )
          )}

          {activeComponent === 'individualRecords' && (
            <IndividualContainerDivs id='print-area' >
              <IndividualPrintStyle />
              <CtnrBtt>
                <ButtonPrint className="no-print" onClick={handlePrintIndividualForm}>Imprimir</ButtonPrint>
              </CtnrBtt>
              <IndividualStudentSection id="printable-content-individualRecords">
                <ContLogo className="cont-logo-individualForm">
                  {(logoUrl) && (
                    <Preview className="logo-individualForm" src={logoUrl} alt="Logo da escola" />
                  )}
                  <h2 className="h2indForm">Fichas Individuais de Alunos</h2>
                </ContLogo>
                <h3>{renderPeriod(bimonthly)}</h3>
                <span><strong>Escola:</strong> {data.nameSchool}</span>

                <span><strong>Ano:</strong> {data.year}</span>
                {data?.serie && (
                  <span><strong>Serie:</strong> {data.serie}</span>
                )}
                <span><strong>Turma:</strong> {data.nameClass}</span>

                {Array.isArray(data.id_individualForm) && data.id_individualForm.length > 0 ? (
                  data.id_individualForm
                    .sort((a, b) => a.id_student.name.localeCompare(b.id_student.name))
                    .map((res, index) => (
                      <IndividualContainerTable key={res._id}>
                        <Span>
                          {Array.isArray(data.idRegentTeacher) && data.idRegentTeacher.includes(res.id_teacher._id) ? (
                            <>
                              <div>Professor Regente Titular: <p>{res.id_teacher.name}</p></div>
                              {data.nameRegentTeacher02 &&
                                data.nameRegentTeacher02 !== "Professor não definido" && (
                                  <div>Professor Regente Adjunto: <p>{data.nameRegentTeacher02}</p></div>
                                )}
                            </>
                          ) : Array.isArray(data.idRegentTeacher02) && data.idRegentTeacher02.includes(res.id_teacher._id) ? (
                            <>
                              {/* Se quem lançou é o Professor 02, mostra os dois */}
                              {data.nameRegentTeacher && data.nameRegentTeacher !== "Professor não definido" && (
                                <div>Professor Regente Titular: <p>{data.nameRegentTeacher}</p></div>
                              )}
                              <div>Professor Regente Adjunto: <p>{res.id_teacher.name}</p></div>
                            </>
                          ) : Array.isArray(data.idPhysicalEducationTeacher) && data.idPhysicalEducationTeacher.includes(res.id_teacher._id) ? (
                            <div>Professor de Ed. Física: <p>{res.id_teacher.name}</p></div>
                          ) : null}


                          <div>Aluno: <p>{res.id_student.name}</p></div>
                        </Span>

                        <IndividualTableRow>
                          <IndividualDescriptionCell>
                            <div className={`description ${expandedRows.includes(index) ? 'expanded' : 'collapsed'}`}>
                              <div
                                style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{
                                  __html: expandedRows.includes(index) || printing
                                    ? res.description
                                    : getDescriptionPreview(res.description),
                                }}
                              />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              {!printing && (
                                <Button onClick={() => toggleRowExpansion(index)} className="no-print">
                                  {expandedRows.includes(index) ? 'Ver Menos' : 'Ver Mais'}
                                </Button>
                              )}
                              {expandedRows.includes(index) && positionAtSchool === 'DIRETOR/SUPERVISOR' && (
                                <Button onClick={() => handleEdit(index, res)} className="no-print">
                                  Editar
                                </Button>
                              )}
                            </div>
                          </IndividualDescriptionCell>
                        </IndividualTableRow>

                        {editingIndex === index && (
                          <EditContainer>
                            <div className="modal-content">
                              <h3>Editando Ficha</h3>
                              <ReactQuill
                                theme="snow"
                                modules={{
                                  toolbar: [
                                    [{ 'font': [] }],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['bold', 'italic', 'underline'],
                                    [{ 'color': [] }, { 'background': [] }],
                                    ['clean']
                                  ]
                                }}
                                value={editedDescription}
                                onChange={(e) => setEditedDescription(e)}
                                placeholder="Descrição da aula"
                                style={{
                                  height: 'auto', // aumentado de 250px para 350px
                                  maxHeight: '550px',
                                  overflow: 'auto',
                                  zIndex: 0,
                                  position: 'relative'
                                }}
                              />
                              {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                              <div style={{ position: 'relative', zIndex: 10, marginTop: '30px', }} className='BoxBtt'>
                                <ButtonEdit onClick={handleSaveEditIndForm}>Salvar</ButtonEdit>
                                <ButtonEdit onClick={() => setEditingIndex(null)}>Cancelar</ButtonEdit>
                              </div>
                            </div>
                          </EditContainer>
                        )}
                      </IndividualContainerTable>
                    ))
                ) : (
                  <InfoText>Não há nenhum registro</InfoText>
                )}
              </IndividualStudentSection>
            </IndividualContainerDivs>
          )}

          {activeComponent === 'finalConcepts' && (
            finalConcepts.length > 0 ? (
              <>
                <ConceptsTableContainer id="printable-content-concepts">
                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}
                    <ContInfo className="info">
                      <h2>Conceitos Finais</h2>
                      <span><strong>Escola:</strong> {quarters[1].nameSchool}</span>

                      <span><strong>Ano:</strong> {quarters[1].year}</span>
                      {quarters[1]?.serie && (
                        <span><strong>Serie:</strong> {quarters[1].serie} - {quarters[1]?.idClass.level}</span>
                      )}
                      <span><strong>Turma:</strong> {quarters[1].nameClass}</span>
                      <span><strong>Professor(a) Regente Titular:</strong> {quarters[3].nameRegentTeacher}</span>
                      {quarters[1].nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor(a) Regente Adjunto:</strong> {quarters[3].nameRegentTeacher02}</span>
                      )}
                      {/*quarters[1].namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor de Ed. Física:</strong> {quarters[1].namephysicalEducationTeacher}</span>
                      )*/}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintconcept}>Imprimir</ButtonPrint>
                  </CtnrBtt>

                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p><strong style={{ color: 'var(--green)' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                    <p><strong style={{ color: '#3b82f6' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                    <p><strong style={{ color: '#e08a0b' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                    <p><strong style={{ color: 'var(--coral, #e5484d)' }}>D</strong> - Não alcançou as capacidades básicas</p>
                  </LegendBox>

                  {/* ✅ Somente a TABELA rola */}
                  <div style={{ overflowX: 'auto' }}>
                    <ConceptsTable>
                      <ConceptsTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>
                          {Array.from(
                            new Map(
                              finalConcepts.map((c) => [
                                c.id_matter._id,
                                c.id_matter.name
                              ])
                            ).entries()
                          ).map(([matterId, matterName]) => (
                            <th key={matterId} className="matter-cell">{matterName}</th>
                          ))}
                        </tr>
                      </ConceptsTableHeader>

                      <ConceptsTableBody>
                        {Object.values(
                          finalConcepts.reduce((acc, concept) => {
                            const studentId = concept.id_student._id;
                            if (!acc[studentId]) {
                              acc[studentId] = {
                                _id: studentId,
                                name: concept.id_student?.name || 'Sem nome',
                                cpf: concept.id_student?.cpf,
                                dateOfBirth: concept.id_student?.dateOfBirth,
                                concepts: {}
                              };
                            }
                            acc[studentId].concepts[concept.id_matter._id] = concept.studentGrade;
                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem conceito
                          (studentsSorted || []).reduce((acc, student) => {
                            acc[student._id] = { _id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, concepts: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student._id}
                              className={`concept-row ${selectedStudentConcept === student._id ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentConcept((prev) =>
                                  prev === student._id ? null : student._id
                                )
                              }
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                              {Array.from(
                                new Map(
                                  finalConcepts.map((c) => [
                                    c.id_matter._id,
                                    c.id_matter.name
                                  ])
                                ).keys()
                              ).map((matterId) => {
                                const concept = student.concepts[matterId] || '-';
                                let conceptClass = '';
                                if (concept === 'A') conceptClass = 'concept-green';
                                else if (concept === 'B') conceptClass = 'concept-blue';
                                else if (concept === 'C') conceptClass = 'concept-orange';
                                else if (concept === 'D') conceptClass = 'concept-red';

                                return (
                                  <td key={matterId} className={`matter-cell ${conceptClass}`}>
                                    {concept}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </ConceptsTableBody>
                    </ConceptsTable>
                  </div>
                </ConceptsTableContainer>

                <ConceptsTableContainer id="printable-content-concepts-physical">

                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <h2>Conceitos Finais - Educação Física</h2>

                      <span><strong>Escola:</strong> {quarters?.[1]?.nameSchool}</span>
                      <span><strong>Ano:</strong> {quarters?.[1]?.year}</span>

                      {quarters?.[1]?.serie && (
                        <span><strong>Serie:</strong> {quarters[1].serie} - {quarters[1]?.idClass.level}</span>
                      )}

                      <span><strong>Turma:</strong> {quarters?.[1]?.nameClass}</span>

                      {quarters?.[3]?.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span>
                          <strong>Professor(a) de Ed. Física:</strong> {quarters[3].namephysicalEducationTeacher}
                        </span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintconceptPhysical}>
                      Imprimir
                    </ButtonPrint>
                  </CtnrBtt>

                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p><strong style={{ color: 'var(--green)' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                    <p><strong style={{ color: '#3b82f6' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                    <p><strong style={{ color: '#e08a0b' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                    <p><strong style={{ color: 'var(--coral, #e5484d)' }}>D</strong> - Não alcançou as capacidades básicas</p>
                  </LegendBox>

                  <div style={{ overflowX: 'auto' }}>
                    <ConceptsTable>

                      <ConceptsTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>

                          {/* Aqui vai ter só EDUCAÇÃO FÍSICA */}
                          {Array.from(
                            new Map(
                              finalConceptsPhysical.map((c) => [
                                c.id_matter._id,
                                c.id_matter.name
                              ])
                            ).entries()
                          ).map(([matterId, matterName]) => (
                            <th key={matterId} className="matter-cell">
                              {matterName}
                            </th>
                          ))}
                        </tr>
                      </ConceptsTableHeader>

                      <ConceptsTableBody>
                        {Object.values(
                          finalConceptsPhysical.reduce((acc, concept) => {
                            const studentId = concept.id_student._id;

                            if (!acc[studentId]) {
                              acc[studentId] = {
                                _id: studentId,
                                name: concept.id_student?.name || 'Sem nome',
                                cpf: concept.id_student?.cpf,
                                dateOfBirth: concept.id_student?.dateOfBirth,
                                concepts: {}
                              };
                            }

                            acc[studentId].concepts[concept.id_matter._id] = concept.studentGrade;

                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem conceito
                          (studentsSorted || []).reduce((acc, student) => {
                            acc[student._id] = { _id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, concepts: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr key={student._id}>
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>

                              {Array.from(
                                new Map(
                                  finalConceptsPhysical.map((c) => [
                                    c.id_matter._id,
                                    c.id_matter.name
                                  ])
                                ).keys()
                              ).map((matterId) => {
                                const concept = student.concepts[matterId] || '-';

                                let conceptClass = '';
                                if (concept === 'A') conceptClass = 'concept-green';
                                else if (concept === 'B') conceptClass = 'concept-blue';
                                else if (concept === 'C') conceptClass = 'concept-orange';
                                else if (concept === 'D') conceptClass = 'concept-red';

                                return (
                                  <td key={matterId} className={`matter-cell ${conceptClass}`}>
                                    {concept}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </ConceptsTableBody>

                    </ConceptsTable>
                  </div>

                </ConceptsTableContainer>
              </>
            ) : (
              <ConceptsTableContainer>
                <div style={{ overflowX: 'auto' }}>
                  <ConceptsTable>
                    <tr>
                      <td>Não há conceitos registrados</td>
                    </tr>
                  </ConceptsTable>
                </div>
              </ConceptsTableContainer>
            )
          )}

          <ToGoBack onClick={() => window.history.back()} className="no-print">
            <SignMessageButtonText>Voltar para a</SignMessageButtonText>
            <SignMessageButtonTextBold>Página Anterior</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      }

    </Container >
  );
}